import { useState } from "react";
import axios from "axios";
import { PlayCircle, Loader2 } from "lucide-react";
import { API } from "@/portal/AuthContext";

// „Live-Demo ansehen“: passwortloser Einstieg in den Kundenbereich als Robbie Roboter (Demo GmbH).
// Setzt serverseitig ein kurzes Demo-Cookie und lädt /portal neu, damit der Demo-Kontext greift.
export const DemoButton = ({ className = "", variant = "solid", label = "Live-Demo ansehen", testId = "demo-start-btn" }) => {
  const [loading, setLoading] = useState(false);
  const start = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await axios.post(`${API}/demo/start`, {}, { withCredentials: true, headers: { "X-Requested-With": "XMLHttpRequest" } });
      window.location.assign("/portal");
    } catch {
      setLoading(false);
      window.location.assign("/portal");  // Cookie ist i. d. R. gesetzt – zur Not trotzdem versuchen
    }
  };
  const base = "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border-2 border-[#111] px-6 py-3.5 text-[15px] font-bold text-[#111] transition-transform hover:-translate-y-0.5 active:translate-y-0";
  const styles = variant === "solid"
    ? "bg-white shadow-[0_6px_0_0_#111] active:shadow-[0_3px_0_0_#111]"
    : "bg-transparent hover:bg-[#111] hover:text-white";
  return (
    <button type="button" onClick={start} disabled={loading} data-testid={testId} className={`${base} ${styles} ${className}`}>
      {loading ? <Loader2 size={18} className="animate-spin" /> : <PlayCircle size={18} strokeWidth={2.5} />}
      {loading ? "Demo wird geöffnet …" : label}
    </button>
  );
};
